<template>
  <div class="multi-select">
    <ProvideStateTriggeredBySlotProps v-slot="{ turnOff, toggle, isOn }">
      <BasePopper
        v-click-outside="turnOff"
        default-slot-is-inline
        :display="isOn"
        :strategy="fixed ? 'fixed' : 'absolute'"
        :arrow="false"
      >
        <WdsButtonGhost v-if="ghostButton" v-bind="$attrs" @click="toggle">
          <div :class="{ 'pull-left': !noCaret, inline: true }" data-test="contentSlot">
            <slot />
          </div>
          <div v-if="!noCaret" class="pull-right m-l-10" data-test="caretSlot">
            <i
              class="fa"
              :class="{ 'fa-caret-down': !isOn, 'fa-caret-up': isOn }"
              aria-hidden="true"
            ></i>
          </div>
        </WdsButtonGhost>
        <BaseButton v-else v-bind="$attrs" class="f-14" @click="toggle">
          <div :class="{ 'pull-left': !noCaret, inline: true }" data-test="contentSlot">
            <slot />
          </div>
          <div v-if="!noCaret" class="pull-right m-l-10" data-test="caretSlot">
            <i
              class="fa"
              :class="{ 'fa-caret-down': !isOn, 'fa-caret-up': isOn }"
              aria-hidden="true"
            ></i>
          </div>
        </BaseButton>
        <template #popper>
          <slot name="dropdown" />
        </template>
      </BasePopper>
    </ProvideStateTriggeredBySlotProps>
  </div>
</template>

<script>
import { WdsButtonGhost } from '@worksome/wds-components'
import BasePopper from '@/components/BasePopper.vue'
import BaseButton from '@/components/BaseButton.vue'
import ProvideStateTriggeredBySlotProps from '@/components/ProvideStateTriggeredBySlotProps.vue'

/**
 * Button with dropdown <br>
 * $attrs passed to `<base-button>`
 */
export default {
  components: { WdsButtonGhost, BaseButton, BasePopper, ProvideStateTriggeredBySlotProps },
  props: {
    /**
     * Render without a right-aligned caret
     */
    noCaret: {
      type: Boolean,
      default: false,
    },
    ghostButton: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
